class FurnaceNotCollectingMessage {
	static protocol = {}

	constructor() {}
}

export default FurnaceNotCollectingMessage
